import {initState} from './store';

const universityStore = () =>
{

  const setData = ({type, data}, globalState) => ({[type]: data});

  const initialState = (payload, globalState) => ({
    administrativestaffs: [],
    accreditations: [],
    accrs: [],
    offlineenrollmentrequirements: [],
    annualprofessionaldevelopmentplans: [],
    enrolled: [],
    aaims: [],
    pdc_aims: [],
    aannualprograms: [],
    achievements: [],
    academiccalendars: [],
    acapacitybuildings: [],
    generals: [],
    acouncilscommittees: [],
    aggrements: [],
    amanualpolicies: [],
    selfassesments: [],
    kankorregistrationdates: [],
    periodicprogramreviews: [],
    avissionmissionimages: [],
    boardinfos: [],
    boardmembers: [],
    boardposts: [],
    capacitybuildings: [],
    ccurriculums: [],
    curriculums: [],
    ceabouts: [],
    ceaggrements: [],
    cemissions: [],
    ceorganizationalstructures: [],
    cevissions: [],
    chancellormessages: [],
    kankorguides: [],
    contactinfos: [],
    contactus: [],
    eligibilitycriterias: [],
    faculties: [],
    heros: [],
    histories: [],
    jobs: [],
    libraries: [],
    libraryinfos: [],
    labs: [],
    magazines: [],
    migrationpolicies: [],
    news: [],
    foundation: [],
    orgstructures: [],
    pdcstructures: [],
    pdcposts: [],
    policiesandprocedures: [],
    pdcstaticks: [],
    penalties: [],
    raims: [],
    researchpublications: [],
    researchpapersandpublications: [],
    researchsupports: [],
    researchpapers: [],
    researchguides: [],
    researchtrainings: [],
    rmanualpolicies: [],    
    planedresearches: [],
    underprocessresearches: [],
    completedresearches: [],
    publishedresearches: [],
    scholarshipsfinancings: [],
    semesterpromotionrules: [],
    stratigicaims: [],
    seminarscoursesworkshops: [],
    scientificandresearchmagazines: [],
    teachers: [],
    pdcstudents: [],
    societies: [],
    students: [],
    values: [],
    strategicplanes: [],
    structures: [],
    activities: [],
    semesterfees: [],
    councilsandcommittees: [],
    academicprograms: [],
    digitallibraries: [],
    onlinelibraries: [],
    procedures: [],
    offlinelibraries: [], 
    progressiveplans: [],
    studystatistics: [], 
    studentsengagements:[],
    studentsexperiences: [],
    toursofstudents: [],
    studentsstatistics: [],
    tajils : [],
    depriveds: [],
    chances: [],
    reenrollments: [],
    eresticates: [],
    transformations: [],
    repeats: [],
    graduates: [],
    graduatedstudentsstatistics: [],
    employedstudents: [],
    counselingcenters: [],
    alumni:[],
    latestpublishes:[],

  });
  
  return initState({
    initialState, 
    setData, 
  })
}


export default universityStore;